import { render, staticRenderFns } from "./UploadAds.vue?vue&type=template&id=5ae417a6&"
import script from "./UploadAds.vue?vue&type=script&lang=js&"
export * from "./UploadAds.vue?vue&type=script&lang=js&"
import style0 from "./UploadAds.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports